import { mapState } from 'vuex';
import WrapWithStatusIcon from "@/components/seo/WrapWithStatusIcon";
import WrapWithCopy from "@/components/WrapWithCopy";
import AppTd from "@/components/AppTd";
import AppPopover from "@/components/AppPopover";
export default {
  name: "SeoBulletPointCell",
  components: {
    WrapWithStatusIcon,
    WrapWithCopy,
    AppTd,
    AppPopover
  },
  emits: ["onEdit", "onPaste", "isCopied", "onCopyingHover", "onCopyingHoverLeave"],
  props: {
    bullet_point: Object,
    item: Object,
    showPopover: Boolean,
    index: Number
  },
  data() {
    return {
      isClicked: false
    };
  },
  computed: {
    ...mapState({
      is_copying: state => state.content.is_copying
    })
  },
  watch: {
    is_copying() {
      if (!this.is_copying) {
        this.isClicked = this.is_copying;
      }
    },
    index() {
      //console.log("new index",index);
    }
  },
  methods: {
    handleCopied() {
      const refEl = this.$refs[this.bullet_point.id];
      if (!refEl) {
        return;
      }
      this.isClicked = true;
      this.$emit("isCopied", refEl);
    }
  }
};